'use strict';

angular.module('licensure.services')
    .factory('InternalPage', ['$http', '$q', '$rootScope', 'Cache', function ($http, $q, $rootScope, Cache) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/Core/PageObjects', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        return null;
                    });

                return d.promise;
            }
        }
    }])
;